var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.769241 4.99951C0.769241 2.23809 3.00782 -0.000488281 5.76924 -0.000488281H27.7692C30.5307 -0.000488281 32.7692 2.23809 32.7692 4.99951V26.9995C32.7692 29.7609 30.5307 31.9995 27.7692 31.9995H5.76924C3.00782 31.9995 0.769241 29.7609 0.769241 26.9995V4.99951ZM16.7692 24.616C21.5274 24.616 25.3846 20.7588 25.3846 16.0006C25.3846 11.2425 21.5274 7.38525 16.7692 7.38525C12.0111 7.38525 8.15384 11.2425 8.15384 16.0006C8.15384 20.7588 12.0111 24.616 16.7692 24.616ZM26 8.61467C27.0196 8.61467 27.8461 7.78812 27.8461 6.76852C27.8461 5.74891 27.0196 4.92236 26 4.92236C24.9804 4.92236 24.1538 5.74891 24.1538 6.76852C24.1538 7.78812 24.9804 8.61467 26 8.61467Z",
    fill: "#F68D10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7692 20.9228C19.4882 20.9228 21.6923 18.7187 21.6923 15.9997C21.6923 13.2808 19.4882 11.0767 16.7692 11.0767C14.0503 11.0767 11.8462 13.2808 11.8462 15.9997C11.8462 18.7187 14.0503 20.9228 16.7692 20.9228Z",
    fill: "#F68D10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b60b443ff96bf2aa0ec76ce71cbf5a75.svg";
export { ForwardRef as ReactComponent };